import { motion } from "framer-motion";
import { MainNav } from "../components/MainNav";
import Hero from "../components/Hero";
import About from "../components/About";
import Contact from "../components/Contact";
import SEOHead from "../components/SEOHead";
import { useLanguage } from "../contexts/LanguageContext";
import { getLocalBusinessSchema, getOrganizationSchema, getWebsiteSchema, getServiceSchema } from "../lib/structuredData";

const Index = () => {
  const { language } = useLanguage();

  const seoContent = {
    title: language === 'sv' 
      ? 'Petrobell - Specialister på marina drivmedel | Bunkring i hela Sverige'
      : 'Petrobell - Marine Fuel Specialists | Bunkering across Sweden',
    description: language === 'sv'
      ? 'Vi levererar alla sorters drivmedel i hela Sverige med bunkerfartyg och tankbilar till sjöstationer, fartyg, entreprenader och statliga myndigheter.'
      : 'We deliver all types of fuels throughout Sweden with bunker vessels and tank trucks to marine stations, vessels, contractors, and government agencies.',
    keywords: language === 'sv'
      ? 'bunkerbränsle, bunkerbränsle Stockholm, marina drivmedel, fartygsbränsle leverans, fartygsleverans bränsle, HVO100, diesel marin, bensin båt, bunkerfartyg, marina gasoil'
      : 'bunker fuel, bunker fuel Stockholm, marine fuel, marine gasoil, ship fuel delivery, fuel delivery ship, HVO100, marine diesel, boat petrol, bunker vessel'
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="bg-white"
    >
      <SEOHead
        title={seoContent.title}
        description={seoContent.description}
        path="/"
        language={language}
        keywords={seoContent.keywords}
        jsonLd={[
          getLocalBusinessSchema(language), 
          getOrganizationSchema(language), 
          getWebsiteSchema(language), 
          getServiceSchema(language)
        ]}
      />
      <MainNav />
      <Hero />
      <About />
      <Contact />
    </motion.div>
  );
};

export default Index;